import { DomainTypeGq } from '../../../../../graphql/projects/models/DomainTypeGq';
import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import { KeywordTableColumn, KeywordTableColumnTypes } from './models';

export const getColumnName = (column: KeywordTableColumn, project: ProjectGq): string => {
  if (column.type === KeywordTableColumnTypes.Keyword) return 'Keyword';
  if (column.type === KeywordTableColumnTypes.EnglishTranslation) return 'English translation';
  if (column.type === KeywordTableColumnTypes.ArchiveTime) return 'Archive time';
  if (column.type === KeywordTableColumnTypes.RankStatus) return 'Rank date';
  if (column.type === KeywordTableColumnTypes.SerpFeatures) return 'SERP features';
  if (column.type === KeywordTableColumnTypes.SeedKeyword) return 'Seed keyword';
  if (column.type === KeywordTableColumnTypes.SeedType) return 'Seed type';
  if (column.type === KeywordTableColumnTypes.KeywordSearch) return 'Keyword search';
  if (column.type === KeywordTableColumnTypes.Volume) return 'Volume';
  if (column.type === KeywordTableColumnTypes.VolumeTrend) return 'Trend';
  if (column.type === KeywordTableColumnTypes.VolumeMonthPeak) return 'Peak month';
  if (column.type === KeywordTableColumnTypes.VolumeQuarterPeak) return 'Peak quarter';
  if (column.type === KeywordTableColumnTypes.Cpc) return 'CPC avg';
  if (column.type === KeywordTableColumnTypes.CpcBidHigh) return 'Bid high';
  if (column.type === KeywordTableColumnTypes.CpcBidLow) return 'Bid low';
  if (column.type === KeywordTableColumnTypes.Competition) return 'Competition';
  if (column.type === KeywordTableColumnTypes.TranslationFrom) return 'Translated from';
  if (column.type === KeywordTableColumnTypes.TranslationFromVolume)
    return 'Translated from volume';
  if (column.type === KeywordTableColumnTypes.VolumeLast12months) return 'Volume 12 months';
  if (column.type === KeywordTableColumnTypes.TagCount) return 'Tag count';

  if (column.type === KeywordTableColumnTypes.Rank) {
    const domain = project.domains.find((d) => d.id === column.id);
    const projectSnippet = domain?.type === DomainTypeGq.PROJECT ? ' (project)' : '';
    const automaticSnippet = domain?.type === DomainTypeGq.AUTOMATIC ? ' (auto)' : '';
    if (domain?.name?.length) return domain.name + projectSnippet + automaticSnippet;
  }

  if (column.type === KeywordTableColumnTypes.TagGroup) {
    const tagGroup = project.tagGroups.find((tg) => tg.id === column.id);
    if (tagGroup?.name?.length) return tagGroup.name;
  }

  return '?';
};
